module.exports = __webpack_public_path__ + "media/tr_tr_s6_Zeynep.832d1f9c.oga";